module.exports = __webpack_public_path__ + "static/media/post-preview-line-break.5fbe2093.svg";